



















import 'vue-awesome/icons/angle-double-right'
export default
  name: 'range_changer'
  props: ['initial_range']
  data: ->
    selected_range: {}
    custom_range:
      key: 'custom'
      start: hm_date.addMonths_f(hm_date.startOfMonth(new Date), -3)
      end: hm_date.addDays_f(hm_date.startOfMonth(new Date), -1)
      type: 'month'
  computed:
    format: ->
      switch @custom_range.type
        when 'month' then "MMM yyyy"
        when 'date'  then "MMM d, yyyy"
        when 'year'  then "yyyy"
    ranges: ->
      ranges = require('./ranges_builder.coffee')
      ranges.compare_periods(@$store.getters.first_transaction_date)
    custom_range_start:
      get: ->
        switch @custom_range.type
          when 'month' then hm_date.startOfMonth(@selected_range.start).toUTCString()
          when 'date'  then hm_date.parse(@selected_range.start).toUTCString()
          when 'year'  then hm_date.startOfYear(@selected_range.start).toUTCString()
      set: (val) -> @selected_range.start = hm_date.format(val)
    custom_range_end:
      get: ->
        switch @custom_range.type
          when 'month' then hm_date.endOfMonth(@selected_range.end).toUTCString()
          when 'date'  then hm_date.parse(@selected_range.end).toUTCString()
          when 'year'  then hm_date.endOfYear(@selected_range.end).toUTCString()
      set: (val) ->
        @selected_range.end = switch @custom_range.type
          when 'month' then hm_date.endOfMonth_f(val)
          when 'date'  then hm_date.format(val)
          when 'year'  then hm_date.endOfYear_f(val)
  mounted: ->
    if @initial_range
      @selected_range = _.find _.flatten(_.map(@ranges, 'ranges')), { key: @initial_range }
    f = => @$emit('change', @selected_range)
    @$watch 'selected_range', f, { immediate: @initial_range, deep: true }
